import React from "react";
import PageContainer from "layout/default-sidebar-layout/PageContainer";
import { Button, Icon } from "antd";
import { autobind } from "core-decorators";
import OrganizationApi from "api/OrganizationApi";
import OrganizationForm from "../organization-form";
import slug from "/constants/slug";
import createManagerEdit from "hoc/manager-edit";
import PropTypes from "prop-types";
import Breadcrumb from "../breadcrumb";
import { message } from "antd";

@createManagerEdit({
  apiUpdate: OrganizationApi.updateOne,
  apiGetByKey: OrganizationApi.getOne,
})
@autobind
export default class OrganizationEdit extends React.PureComponent {
  static propTypes = {
    onDeleteItem: PropTypes.func,
    onUpdateItem: PropTypes.func,
    getItem: PropTypes.func,
    isLoaded: PropTypes.bool,
  };

  async handleSubmit(data) {
    // console.log("handleSubmit----handleSubmit",data)
    const res = await OrganizationApi.updateOne(this.props.data._id, data);
    if (res.success || res.data)
      message.info(this.props.lang.t("addon.onSave.update.success"));
    else message.error(this.props.lang.t("addon.onSave.update.error"));
    this.props.history.push(slug.organization.list);
  }

  //Su kien truoc khi component duoc tao ra
  async componentWillMount() {
    await this.props.getItem();
  }

  // Su kien xoa measuring
  deleteStationType() {
    const key = this.props.match.params.key;
    this.props.onDeleteItem(key, () => {
      this.props.history.push(slug.stationType.list);
    });
  }

  buttonDelete() {
    return (
      <div>
        <Button type="primary" onClick={this.deleteStationType}>
          <Icon type="delete" />
          Delete
        </Button>
      </div>
    );
  }

  render() {
    return (
      <PageContainer button={this.buttonDelete()} {...this.props.wrapperProps}>
        <Breadcrumb
          items={[
            "list",
            {
              id: "edit",
              name: this.props.isLoaded ? this.props.data.name : null,
            },
          ]}
        />
        {this.props.isLoaded && this.props.data && (
          <OrganizationForm
            initialValues={this.props.isLoaded ? this.props.data : {}}
            onSubmit={this.handleSubmit}
            isEdit
          />
        )}
      </PageContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/organization/organization-edit/index.js